const ENDPOINT = new Map();

ENDPOINT.set('get', '/exam/attempt/get');
ENDPOINT.set('rate', '/exam/comment/add');

export default ENDPOINT